module.exports = __webpack_public_path__ + "static/media/shield-alt.72940fd8.svg";